import type { Banner } from '@skippay/core/modules/banners/types';

import { outagesSource, transactionsSource } from './sources/activity';
import {
	deferredPaymentsSource,
	installmentsSource,
	payInThreeSource,
} from './sources/applications';
import { billingSource, contractSource } from './sources/contract';
import { offersSource } from './sources/offers';
import { complianceSource, eligibilitySource } from './sources/profile';
import { cardSource, cashbackSource, coinsSource } from './sources/rewardsAndCard';
import { ContextAdapter } from './types';

export const createSelfCareContextAdapter = (getBanners: () => Banner[]): ContextAdapter => [
	eligibilitySource,
	complianceSource,
	contractSource,
	billingSource,
	payInThreeSource,
	deferredPaymentsSource,
	installmentsSource,
	coinsSource,
	cashbackSource,
	cardSource,
	transactionsSource,
	outagesSource,
	offersSource(getBanners),
];
